<template>
    <a rel="nofollow" :href="link">
        <slot />
    </a>
</template>

<script>
export default {
    name: "TgpLink",
    props: {
        item: {type: Object, required: true},
        urlConfig: {type: Object, required: true},
    },

    computed: {
        link() {
            let {joinUrl, carryOverUrl, defaultCarryOver} = this.urlConfig;

            const carryOver = this.item.movie_id ? `movie.${this.item.movie_id}` : defaultCarryOver;
            if (carryOverUrl && carryOver) {
                return carryOverUrl + '?return_url=' + encodeURIComponent(joinUrl) + '&carry=' + encodeURIComponent(carryOver + '.external');
            }

            return joinUrl;
        },
    },
}
</script>
